import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';

@Injectable()
export class CandidateService {

  constructor(private http: HttpClient) {}

  getCandidatesByContestId(contestId) {
    return this.http
      .get(`Landing/candidates?contestId=${contestId}`)
      .map(response => {
          response = response;
          return response;
        },
        (err) => console.log(err));
  }

  voteRecord(voters) {
    return this.http
      .post('voting/record', voters)
      .map(response => {
          response = response;
          return response;
        },
        (err) => console.log(err));
  }

  getCandidateDetailById(candidateId:number) {
    return this.http
      .get(`Landing/candidatedetail?candidateId=${candidateId}`)
      .map(response => {
          response = response;
          return response;
        },
        (err) => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./src/app/service/candidate.service.ts